/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unlinkCard} from '../api'

export const useMutationUnlinkCard = createReactQueryMutationHook('unlinkCard', unlinkCard)
